var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DeleteConfirm',{attrs:{"selectedItem":_vm.getSelectedForum,"toolbarTitle":_vm.computedTitle,"deleteMessage":_vm.computedDeleteMessage,"checkboxDeleteMessage":_vm.$t('Diese Aktion kann nicht rückgängig gemacht werden.')},on:{"deleteItem":_vm.deleteForum,"closeEmit":_vm.close}})
}
var staticRenderFns = []

export { render, staticRenderFns }